<template>
  <div ref="PlanetCity" id="PlanetCity" class="planet_city_animate_wrap">
    <video
        class="bg_video"
        :style="{width: `${defaultWidth}px`, height: `${defaultHeight}px`}"
        autoplay
        muted
        loop
    >
      <source :src="planetCityVideoBg" type="video/webm">
    </video>
    <div class="cpu_wrap">
      <div class="type_label">{{nowCpuLoad.type_label}}</div>
      <div class="value_label">{{ nowCpuLoad.value_label }}</div>
      <div class="unit_label">{{nowCpuLoad.Unit}}</div>
    </div>
    <div class="gpu_wrap">
      <div class="type_label">{{nowGpuLoad.type_label}}</div>
      <div class="value_label">{{nowGpuLoad.value_label}}</div>
      <div class="unit_label">{{nowGpuLoad.Unit}}</div>
    </div>
    <div class="time_wrap">
      <span class="unit_label">{{nowDateTimeObj.obj.a}}</span>
      <span class="time_label">{{nowDateTimeObj.obj.time}}</span>
    </div>
    <div class="cpu_temp_wrap">
      <div class="type_label">{{nowCpuTemp.type_label}}</div>
      <div class="value_label">{{nowCpuTemp.value_label}}</div>
      <div class="unit_label">{{nowCpuTemp.Unit}}</div>
    </div>
    <div class="gpu_temp_wrap">
      <div class="type_label">{{nowGpuTemp.type_label}}</div>
      <div class="value_label">{{nowGpuTemp.value_label}}</div>
      <div class="unit_label">{{nowGpuTemp.Unit}}</div>
    </div>
  </div>
</template>

<script setup>
import planetCityVideoBg from '@/assets/planetCity/planet_city_video_bg.webm'
import defaultValue from "@/utils/defaultValue"
import {onMounted, onUnmounted, reactive, ref, watch} from "vue";
import moment from "moment/moment";
const {defaultWidth, defaultHeight} = defaultValue()
const props = defineProps(['sensorValue'])
const nowCpuTemp = reactive({
  type_label: 'CPU',
  value_label: '--',
  Unit: '°F'
})
const nowGpuTemp = reactive({
  type_label: 'GPU',
  value_label: '--',
  Unit: '°F'
})
const nowCpuLoad = reactive({
  type_label: 'CPU',
  value_label: '--',
  Unit: '%'
})

const nowGpuLoad = reactive({
  type_label: 'GPU',
  value_label: '--',
  Unit: '%'
})

let nowDateTimeObj = reactive({obj: {}})
let timeTiger = ref(null)
const startTime = () => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  const nowDate = moment().format('HH:mm,a').split(',')
  const timeTextObj = {
    time: nowDate[0], // 時間
    a: nowDate[1].toUpperCase() // am,pm
  }
  nowDateTimeObj.obj = timeTextObj
  timeTiger.value = setTimeout(function () {
    startTime()
  }, 150)
}


watch(
    props.sensorValue,
    (n) => {
      if (n) {
        const {
          CPULoad,
          CPUTemperature,
          GPULoad,
          GPUTemperature
        } = n
        if (CPULoad && Object.keys(CPULoad).length > 0) {
          Object.assign(nowCpuLoad, CPULoad, {
            type_label: `${CPULoad.Type}`,
            value_label: parseInt(CPULoad.Value) > 0 ? CPULoad.Value : '--'
          })
        }
        if (CPUTemperature && Object.keys(CPUTemperature).length > 0) {
          Object.assign(nowCpuTemp, CPUTemperature, {
            value_label: parseInt(CPUTemperature.Value) > 0 ? CPUTemperature.Value : '--'
          })
        }
        if (GPULoad && Object.keys(GPULoad).length > 0) {
          Object.assign(nowGpuLoad, GPULoad, {
            type_label: `${GPULoad.Type}`,
            value_label: parseInt(GPULoad.Value) > 0 ? GPULoad.Value : '--'
          })
        }
        if (GPUTemperature && Object.keys(GPUTemperature).length > 0) {
          Object.assign(nowGpuTemp, GPUTemperature, {
            value_label: parseInt(GPUTemperature.Value) > 0 ? GPUTemperature.Value : '--'
          })
        }
      }
    },
    {immediate: true}
)

onMounted(() => {
  startTime()
})

onUnmounted(() => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
})


</script>

<style lang="scss">
@import "src/assets/scss/font-family";

.planet_city_animate_wrap {
  position: relative;
  .bg_video {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .cpu_wrap {
    position: absolute;
    top: 54px;
    left: 74px;
    width: 130px;
    font-family: HyperspaceRace_BoldItalic;
    .type_label {
      font-size: 28px;
      color: #121B34;
      text-align: center;
      line-height: 1;
      margin-bottom: -6px;
      text-shadow: 0px 0px 6px #FFFFFFE6;
    }
    .value_label {
      font-size: 88px;
      color: #FFFFFF;
      text-align: center;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
    .unit_label {
      font-size: 35px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      margin-top: 6px;
      text-shadow: 0px 0px 6px #000000;
    }
  }

  .gpu_wrap {
    width: 86px;
    position: absolute;
    top: 79px;
    left: 330px;
    font-family: HyperspaceRace_BoldItalic;
    .type_label {
      font-size: 22px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      margin-bottom: -4px;
      text-shadow: 0px 0px 6px #000000;
    }
    .value_label {
      font-size: 57px;
      color: #FFFFFF;
      text-align: center;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
    .unit_label {
      font-size: 25px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      margin-top: -2px;
      text-shadow: 0px 0px 6px #000000;
    }
  }

  .time_wrap {
    width: 202px;
    position: absolute;
    top: 264px;
    left: 33px;
    font-family: HyperspaceRace_BoldItalic;
    .unit_label {
      font-size: 30px;
      color: #FFFFFF;
      line-height: 52px;
      vertical-align: top;
      padding-right: 10px;
      text-shadow: 0px 0px 6px #000000;
    ;
    }
    .time_label {
      font-size: 59px;
      color: #FFFFFF;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
  }

  .cpu_temp_wrap {
    width: 100px;
    position: absolute;
    top: 236px;
    left: 271px;
    font-family: HyperspaceRace_BoldItalic;
    .type_label {
      font-size: 22px;
      color: #FEEC1A;
      text-align: center;
      line-height: 1;
      margin-bottom: -10px;
      text-shadow: 0px 0px 6px #000000;
    }
    .value_label {
      font-size: 58px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
    .unit_label {
      font-size: 25px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      margin-top: -2px;
      text-shadow: 0px 0px 6px #000000;
    }
  }

  .gpu_temp_wrap {
    width: 100px;
    position: absolute;
    top: 236px;
    left: 374px;
    font-family: HyperspaceRace_BoldItalic;
    .type_label {
      font-size: 22px;
      color: #03CECB;
      text-align: center;
      line-height: 1;
      margin-bottom: -10px;
      text-shadow: 0px 0px 6px #000000;
    }
    .value_label {
      font-size: 58px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
    .unit_label {
      font-size: 25px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      margin-top: -2px;
      text-shadow: 0px 0px 6px #000000;
    }
  }
}
</style>
